import { basename } from "helpers/format";
import { each } from "lodash";

const FILE_TYPE_ICONS : any = {};

const svgContext = require.context("./", false, /\.svg$/);
svgContext
  .keys()
  .forEach(
    key =>
      (FILE_TYPE_ICONS[basename(key).replace(".svg", "")] = svgContext(key))
  );

const ICON_TYPES = {
  audio: [
    "aif",
    "cda",
    "mid",
    "midi",
    "mp3",
    "mpa",
    "ogg",
    "wav",
    "wma",
    "wpl",
    "wave",
    "x-wav"
  ],
  database: ["csv", "dat", "db", "log", "mdb", "sav", "sql", "tar"],
  disc: ["bin", "dmg", "iso", "toast", "vdc"],
  ebook: ["epub", "epub+zip", "mobi"],
  exe: [
    "apk",
    "bat",
    "bin",
    "cgi",
    "pl",
    "com",
    "exe",
    "gadget",
    "jar",
    "py",
    "wsf"
  ],
  font: ["fnt", "fon", "otf", "ttf"],
  illustrator: ["ai", "illustrator"],
  image: [
    "bmp",
    "gif",
    "ico",
    "jpeg",
    "jpg",
    "png",
    "ps",
    "svg",
    "tif",
    "tiff"
  ],
  indesign: ["indd", "indl", "indt", "indb", "inx", "idml"],
  keynote: ["key"],
  office_excel: ["xls", "xlsx"],
  office_powerpoint: ["ppt", "pptx", "pps"],
  office_word: ["doc", "docx", "odt", "wks", "wps", "wpd", "msword"],
  pdf: ["pdf"],
  photoshop: ["psd"],
  presentation: ["odp"],
  script: [
    "rb",
    "erb",
    "jsx",
    "asp",
    "aspx",
    "cer",
    "ruby",
    "cfm",
    "cgi",
    "pl",
    "css",
    "htm",
    "html",
    "js",
    "json",
    "javascript",
    "jsp",
    "part",
    "php",
    "py",
    "rss",
    "xhtml",
    "xml"
  ],
  sketch: ["sketch"],
  system: [
    "bak",
    "cab",
    "cfg",
    "nfo",
    "x-nfo",
    "cpl",
    "cur",
    "dll",
    "dmp",
    "drv",
    "icns",
    "ini",
    "lnk",
    "msi",
    "sys",
    "tmp"
  ],
  text: ["rtf", "tex", "txt", "plain", "boxnote", "post"],
  video: [
    "3g2",
    "3gp",
    "avi",
    "flv",
    "h264",
    "m4v",
    "mkv",
    "mov",
    "mp4",
    "mpg",
    "mpeg",
    "rm",
    "swf",
    "vob",
    "wmv"
  ],
  zip: ["7z", "arj", "deb", "pkg", "rar", "rpm", "tar", "gz", "z", "zip"]
};

const ICON_ALIASES : any = {};
each(ICON_TYPES, (extensions, type) =>
  extensions.forEach(extension => (ICON_ALIASES[extension] = type))
);

export function typeForPath(path : string) {
  if (path.indexOf(".") === -1) {
    return;
  }

  const extension = path.split(".").slice(-1)[0];
  const type = ICON_ALIASES[extension] || extension;

  return type;
}

export function typeForItem(item : any) {
  const { path = "", type = "" } = item;

  switch (type.toLowerCase()) {
    case "folder":
      return "folder";

    case "file":
    default:
      return typeForPath(path);
  }
}

export function iconForItem(item : any) {
  const type = typeForItem(item);

  return FILE_TYPE_ICONS[type];
}

export function infoForItem(item : any) {
  const type = typeForItem(item);
  const icon = FILE_TYPE_ICONS[type];

  return {
    icon,
    type
  };
}

export default FILE_TYPE_ICONS;
